import React, {Component} from 'react';
import { withCookies, Cookies } from 'react-cookie';
import {Helmet} from "react-helmet";
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import MapComponent from '../MapComponent/Map';
import {MenuContainer, SelectAreaPopup} from 'common-components';
import * as mapFunctions from '../../modules/mapboxgl/mapFunctions.js';
import {commitMutation, QueryRenderer, graphql} from 'react-relay';
import environment from '../../RelayEnvironment';
import {longTimeoutEnvironment} from '../../RelayEnvironment';
import {fetchApi} from '../../fetchApi';
import '../../css/bootstrap.min.css'
import MapRoomEmbedRoot from './MapRoomEmbedRoot';
import MapRoomCovidRoot from './MapRoomCovidRoot';

class MapRoomRoot extends Component {
    constructor(props) {
        super(props);
        this.testIndicator = {
            indicatorId: "U2VhcmNoYWJsZUluZGljYXRvck5vZGU6NDE=",
            summaryLevelCode: "860",
            "visible": true,
            "index": 0,
            "opacity": 1.0
        };
        var savedAreaIdSelected = props.match.params.areaid;
        if (savedAreaIdSelected != null && savedAreaIdSelected !== "indicator") {
            savedAreaIdSelected = unescape(savedAreaIdSelected);
        } else {
            savedAreaIdSelected = null;
        }

        this.state = {
            isLeftMenuOpen: false,
            refreshLayout: false,
            selectedBoardId: null,
            globallyVisible: true,
            mapInitialized: false,
            mapLayers: [this.testIndicator, null, null, null, null, null, null, null, null, null],
            northwest: [0, 0],
            southeast: [0, 0],
            savedAreaIdSelected: savedAreaIdSelected, //'U2F2ZWRBcmVhTm9kZTo0NDU='
            isSelectAreaPopUpVisible: false,
            xOriginTagCrossPopUp: 345,
            yOriginTagCrossPopUp: 150,
            selectedCardForMutation: null,
            isMorePopUpVisible: false,
            xOriginForMorePopUp: 415,
            yOriginForMorePopUp: 150,
            filterByArea: savedAreaIdSelected != null || props.location.search != "",
            oneTimeMapZoomToArea: savedAreaIdSelected != null,
            isSaveMapPopUpVisible: false,
            isShareMapPopUpVisible: false,
            savingAreaInProgress: false,
        }
        this.map = null;
        this.mapSavedAreaId = savedAreaIdSelected;
        this.mapSelectedGeographicEntity = null;
        this.notifiedDriftBot = false;
        this.indicatorData = {};
        this.indicatorDataForArea = {};
        this.indicatorLabels = {};
        this.shapeStyles = null;
        this.findLayerByIndicatorId = mapFunctions.findLayerByIndicatorId.bind(this);
        this.findLayerConfigByIndicatorId = mapFunctions.findLayerConfigByIndicatorId.bind(this);
        this.fitMapToExtent = mapFunctions.fitMapToExtent.bind(this);
        this.flyMapToExtent = mapFunctions.flyMapToExtent.bind(this);
        this.moveAndZoomMap = mapFunctions.moveAndZoomMap.bind(this);
        this.handleMapMoved = mapFunctions.handleMapMoved.bind(this);
        this.handleMapLayerGeographyChanged = mapFunctions.handleMapLayerGeographyChanged.bind(this);
        this.handleMapLayerOpacityChanged = mapFunctions.handleMapLayerOpacityChanged.bind(this);
        this.handleMapLayerPaletteChanged = mapFunctions.handleMapLayerPaletteChanged.bind(this);
        this.handleMapLayerPositionChanged = mapFunctions.handleMapLayerPositionChanged.bind(this);
        this.handleMapLayerRemoved = mapFunctions.handleMapLayerRemoved.bind(this);
        this.handleMapLayerVisibilityChanged = mapFunctions.handleMapLayerVisibilityChanged.bind(this);
        this.handleMapRenderComplete = mapFunctions.handleMapRenderComplete.bind(this);
        this.loadIndicatorData = mapFunctions.loadIndicatorData.bind(this);
        this.loadIndicatorDataForArea = mapFunctions.loadIndicatorDataForArea.bind(this);
        this.loadPreloadedIndicatorLayers = mapFunctions.loadPreloadedIndicatorLayers.bind(this);
        this.refreshMapLayerSource = mapFunctions.refreshMapLayerSource.bind(this);
        this.renderMap = mapFunctions.renderMap.bind(this);
        this.removeMap = mapFunctions.removeMap.bind(this);
        this.setupBaseMapLayers = mapFunctions.setupBaseMapLayers.bind(this);
        this.setPreloadedIndicatorLayers = mapFunctions.setPreloadedIndicatorLayers.bind(this);
        this.updateMapLayer = mapFunctions.updateMapLayer.bind(this);
        this.getMapCenterAndZoom = mapFunctions.getMapCenterAndZoom.bind(this);
        this.getMapPng = mapFunctions.getMapPng.bind(this);
        this.getMapPngUrl = mapFunctions.getMapPngUrl.bind(this);
        this.getMapPdf = mapFunctions.getMapPdf.bind(this);
        this.getMapCenterAndZoom = mapFunctions.getMapCenterAndZoom.bind(this);
        this.setFilterByArea = mapFunctions.setFilterByArea.bind(this);
        this.updateSavedArea = mapFunctions.updateSavedArea.bind(this);
        this.highlightSavedArea = mapFunctions.highlightSavedArea.bind(this);
        this.updateAreaHighlightVisibility = mapFunctions.updateAreaHighlightVisibility.bind(this);
        this.resizeMap = mapFunctions.resizeMap.bind(this);
        this.addHoverPopupToMapLayer = mapFunctions.addHoverPopupToMapLayer.bind(this);
        this.handleMapLayerOutlinesVisibilityChanged = mapFunctions.handleMapLayerOutlinesVisibilityChanged.bind(this);
    }

    componentDidMount() {
        /* link OpenLayers map to component after first render to the DOM */
        //this.renderMap();
        if (this.props.match.params.areaid === "signup") {
            this.openSignUpPopUp();
        } else if (this.props.match.params.areaid === "signin") {
            this.openLoginPopUp();
        }
        this.handleLocationChange(this.props.history.location);
        this.unlisten = this.props.history.listen(this.handleLocationChange);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.match.params.areaid !== this.props.match.params.areaid) {
            if (nextProps.match.params.areaid === "signup") {
                this.openSignUpPopUp();
            } else if (nextProps.match.params.areaid === "signin") {
                this.openLoginPopUp();
            }
        }
    }

    
    closePopups = (callback) => {
        this.setState({
            isSelectAreaPopUpVisible: false,
            isMorePopUpVisible: false,
            isSaveMapPopUpVisible: false,
            isShareMapPopUpVisible: false,
        }, callback);
    }

    hideCarret = () => {

        // console.log("hideCarret is called")
        if (this.state.globallyVisible === true) {
            this.setState({globallyVisible: false});
        }
        else
            this.setState({globallyVisible: true});
    }

    onUpdateTheTopLeftMenu = () => {
        this.setState((prevState) => ({isUpdateTopAndLeftMenu: !prevState.isUpdateTopAndLeftMenu}))
    }

    handleAreaSelection = (id, name) => {
        this.setState({savedAreaIdSelected: id, filterByArea: true},
            () => {
                this.updateSavedArea(this.state.savedAreaIdSelected);
                this.zoomMapAndHighlightArea(this.state.savedAreaIdSelected);
            });
    };

    handleUnsavedAreaSelection = (selectedValue) => {
        this.mapSelectedGeographicEntity = selectedValue;
    }

    handleDownloadMap = (downloadType) => {
        if (downloadType === "PNG") {
            this.getMapPng();
        }
        else {
            this.getMapPdf();
        }
    };

    handleGoHome = () => {
        this.setState({
            redirect: true
        })
    };

    handleBoardSelection = (id, name, componentType, fromPage) => {
        this.setState(
            {selectedBoardId: id, selectedBoardName: name, selectedComponentType: componentType},
            () => {
                window.location.assign('/board/' + componentType + "/" + fromPage + "/" + escape(id) + "/" + escape(name))
            }
        )
    }

    handleHomeSelection = (componentType, filterTag, isPermaTag) => {
        this.setState((prevState) => (
                {
                    selectedComponentType: componentType,
                    filterTag,
                    isPermaTag: isPermaTag,
                    redirectRoute: '/' + componentType,
                    isHomeStoryVisible: !prevState.isHomeStoryVisible
                }),
            () => {
                if (filterTag == null) {
                    window.location.assign('/board/' + componentType);
                } else {
                    window.location.assign('/board/' + componentType + "/" + filterTag + "/" + (isPermaTag ? 1 : 0));
                }
            }
        )
    }

    routeToProjectBoardHomeFeed = () => {
        if (this.state.redirect) {
            window.location.assign('/board/HOME');
        }
    }

    // toggle popup menus
    showPopUp = (x, y, popUpType, cardId) => {
        if (popUpType === "CloseTag") {
            this.setState((prevState) => {
                return {
                    isSelectAreaPopUpVisible: !prevState.isSelectAreaPopUpVisible,
                    selectedCardForMutation: cardId
                }
            })
        } else if (popUpType === "MoreInfo") {
            this.setState((prevState) => {
                return {
                    isMorePopUpVisible: !prevState.isMorePopUpVisible,
                    selectedCardForMutation: cardId
                }
            })
        }
    };

    hidePopUp = (popUpType) => {
        if (this.state.isSelectAreaPopUpVisible) {
            this.setState({isSelectAreaPopUpVisible: false})
        }
        if (this.state.isMorePopUpVisible) {
            this.setState({isMorePopUpVisible: false})
        }
    };

    showSaveMapPopUp = () => {
        this.closePopups(() => {
            this.setState({isSaveMapPopUpVisible: true});
            this.props.history.push({
                pathname: this.props.history.location.pathname,
                search: this.props.history.location.search,
                hash: "#save"
            })
        });
    };

    showShareMapPopUp = () => {
        this.closePopups(() => {
            this.setState({isShareMapPopUpVisible: true});
        });
    };

    // stub method used when updating saved card in project board from geo tag
    handleSaveCardsPopUp = (x, y, cardId, reason) => {
        console.log("handleSaveCardsPopUp", x, y, reason);
    };

    handleFilterByAreaChange = () => {
        // if no saved area selected and user tries to turn on area filter
        if (this.mapSavedAreaId == null && !this.state.filterByArea) {
            // if a geographic entity is selected in search bar, create new area automatically
            if (this.mapSelectedGeographicEntity != null) {
                this.handleCreateAreaFromGeographicEntity(this.mapSelectedGeographicEntity);
            } else {
                // otherwise, open list of saved areas for selection
                this.handleMenuSelectArea();
            }
            return;
        }
        // toggle filter on already selected saved area
        this.setState((prevState) => {
                return {filterByArea: !prevState.filterByArea}
            },
            () => {
                this.setFilterByArea(this.state.filterByArea)
            });
    }

    handleCreateAreaFromGeographicEntity = (geographicEntity) => {
        //  call GraphQL mutation to create area for user then select it
        if (this.state.savingAreaInProgress === true) {
            return;
        }
        this.setState({savingAreaInProgress: true});

        const mutation = graphql`
            mutation RootCreateAreaMutation($input: CreateSavedAreaFromGeographicEntityInput!) {
                createSavedAreaFromGeographicEntity(input: $input) {
                    savedAreaNode {
                        id
                    }
                }
            }
            `;

        const variables = {
            "input": this.mapSelectedGeographicEntity
        };

        // TODO: add error handling and better responsive progress dialogue
        commitMutation(
            longTimeoutEnvironment,
            {
                mutation,
                variables,
                onCompleted: (response, errors) => {
                    console.log('Response received from server.');
                    this.setState({savingAreaInProgress: false});
                    this.mapSavedAreaId = response.createSavedAreaFromGeographicEntity.savedAreaNode.id;
                    this.setState((prevState) => {
                            return {filterByArea: true}
                        },
                        () => {
                            this.setFilterByArea(this.state.filterByArea);
                            this.handleAreaSelection(this.mapSavedAreaId, null);
                        });
                },
                onError: (err) => {
                    console.error(err);
                    alert('Error saving area');
                    this.setState({savingAreaInProgress: false});
                    this.mapSavedAreaId = null;
                    this.setState((prevState) => {
                            return {filterByArea: false}
                        },
                        () => {
                            this.setFilterByArea(this.state.filterByArea);
                        });
                },
            },
        );
    }

    openSignUpPopUp = () => {
        window.location.assign('/board/signin/');
        //this.setState({ isLoginPopUpVisible: false, isSignupPopUpStep1Visible: true, isForgotPasswordPopUpVisible: false })
    }

    openForgotPasswordPopUp = () => {
        this.setState({
            isLoginPopUpVisible: false,
            isSignupPopUpStep1Visible: false,
            isForgotPasswordPopUpVisible: true
        })
    }

    openLoginPopUp = () => {
        if (this.props.history.location.state != null &&
            this.props.history.location.state.requestedPage != null) {
            this.props.cookies.set('requestedMapPage', this.props.history.location.state.requestedPage, {
                path: '/',
                maxAge: 1800
            });
        }
        window.location.assign('/board/signin/');
        //this.setState({ isLoginPopUpVisible: true, isSignupPopUpStep1Visible: false, isForgotPasswordPopUpVisible: false })
    }

    handleMenuSelectArea = () => {
        this.showPopUp(0, 0, "CloseTag", null)
        this.setState({isMorePopUpVisible: false});
    };

    handleMenuMaskToggle = () => {
        this.handleFilterByAreaChange();
        this.setState({isMorePopUpVisible: false});
    };

    handleMenuSaveMap = () => {
        this.showSaveMapPopUp();
    };

    handleMenuExportMap = () => {
        this.showShareMapPopUp();
    };

    handleMenuDownloadData = (noDataFound = false) => {
        this.setState({isMorePopUpVisible: false});
        if (noDataFound !== true) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'datadownload'
            });
            console.log("data download logged");
        }
    };

    zoomMapAndHighlightArea = async (savedAreaId, highlightOnly = false) => {
        let formdata = {
            "query": `
      query MapRoomRootSelectedAreaQuery($input: ID!) {
        savedArea(id: $input) {
              id
              jsonid
              name
              typeOfArea
              extent
              primaryGeoIdList
            }
      }
    `, "variables": {"input": savedAreaId}
        };
        let response = await fetchApi("graphql", JSON.stringify(formdata))
        if (response.data && response.data.savedArea) {
            if (highlightOnly !== true) {
                let extent = response.data.savedArea.extent;
                this.fitMapToExtent(null, extent);
                if (this.state.oneTimeMapZoomToArea === true) {
                    this.setState({oneTimeMapZoomToArea: false});
                }
            }
            this.highlightSavedArea(response.data.savedArea.typeOfArea,
                response.data.savedArea.primaryGeoIdList);
        }
    }

    handleSelectedArea = (selectedArea) => {
        window.location.assign('/board/areaselector/' + selectedArea)
    };

    openCloseServiceSelector = (isSelectAreaPopUpVisible) => {
        this.setState({isSelectAreaPopUpVisible})
    }

    updateMapStyleCallback = (option) => {
        if(option === "countyoutlines") {
            this.setState((prevState) => {return {isCountyBoundariesVisible: !prevState.isCountyBoundariesVisible}},
        () => {this.handleMapLayerOutlinesVisibilityChanged('050', this.state.isCountyBoundariesVisible)});
        }
    }

    render() {
        const query = new URLSearchParams(this.props.location.search);
        const mapCardIdToLoad = query.get('id');
        const mapBaseStyleToLoad = query.get('style');
        //console.log("mapBaseStyleToLoad", mapBaseStyleToLoad);
        //https://localhost:3000/map?id=Qm9hcmRDYXJkVXNlTm9kZToxMDY=
        //https://localhost:3000/map/U2F2ZWRBcmVhTm9kZTo0NDU%3D?id=Qm9hcmRDYXJkVXNlTm9kZToxMDY=
//    console.log(mapCardIdToLoad);
        if (mapCardIdToLoad != null && mapCardIdToLoad !== "") {
            return <QueryRenderer
                environment={environment}
                query={graphql`
              query RootCardQuery($input: ID!) {
                boardCardUse(id: $input) {
                  configuration {
                    title
                    savedArea {
                      id
                      name
                    }
                    mapZoom
                    mapCenterLng
                    mapCenterLat
                    mapLayers {
                      edges {
                        node {
                          indicator {
                            id
                            indicatorName
                            geographicUnit {
                              name
                              summaryLevelCode
                            }
                          }
                          alpha
                          palette
                          position
                          isVisible
                        }
                      }
                    }
                  }
                }
                currentUser
                {
                  edges
                  {
                    node
                    {
                      jsonid
                      username
                      userFirstName
                      userReportName
                      userImage
                      {
                          url
                      }
                    }
                  }
                }

              }
          `}
                variables={{"input": mapCardIdToLoad, userId: this.state.userId}}
                render={({error, props}) => {
                    if (error) {
                        console.error(error);
                        return <div>Error!</div>;
                    }
                    if (!props) {
                        return <div/>
                    }
                    var userDataProps = props;

                    if ((userDataProps.currentUser == null || !userDataProps.currentUser.edges.length) &&
                        (this.props.location.pathname !== "/signin" &&
                            this.props.location.pathname !== "/signup")) {
                        this.props.history.push("/signin", {"requestedPage": "/map" + this.props.location.pathname + this.props.location.search})
                    }
                    if ((userDataProps.currentUser != null && userDataProps.currentUser.edges.length) &&
                        (this.props.location.pathname === "/signin" ||
                            this.props.location.pathname === "/signup")) {
                        this.props.history.push("/")
                    }

                    if (window.drift != null && this.notifiedDriftBot === false && userDataProps.currentUser != null && userDataProps.currentUser.edges[0] != null) {
                        window.drift.on('ready', function () {
                            window.drift.api.setUserAttributes({
                                email: userDataProps.currentUser.edges[0].node.username,
                                nickname: userDataProps.currentUser.edges[0].node.userFirstName
                            });
                        });
                        this.notifiedDriftBot = true;
                    }
                    if (window.Appcues != null && userDataProps.currentUser != null && userDataProps.currentUser.edges[0] != null) {
                        if(window.driftUserAttributes == undefined || window.driftUserAttributes.email !== 
                        userDataProps.currentUser.edges[0].node.username) {
                            window.driftUserAttributes = {
                                email: userDataProps.currentUser.edges[0].node.username,
                                nickname: userDataProps.currentUser.edges[0].node.userFirstName
                            }
                            window.Appcues.identify(userDataProps.currentUser.edges[0].node.id, {
                                    firstName: window.driftUserAttributes.nickname,
                                    email: window.driftUserAttributes.email
                                });
                        }
                    }
                    var savedAreaIdSelected = this.state.savedAreaIdSelected;
                    if (savedAreaIdSelected == null && props.boardCardUse.configuration.savedArea != null) {
                        savedAreaIdSelected = props.boardCardUse.configuration.savedArea.id;
                        //this.updateSavedArea(savedAreaIdSelected);
                    } else if (props.boardCardUse.configuration.savedArea == null) {
                        //this.updateSavedArea(this.state.savedAreaIdSelected);
                    }
                    this.mapSavedAreaId = savedAreaIdSelected;
                    //console.log("datainfo json------->",JSON.stringify(props))
                    return (
                        <MenuContainer handleBoardSelection={this.handleBoardSelection}
                                       hideCarret={this.hideCarret}
                                       goHome={this.handleGoHome}
                                       onUpdateTheTopLeftMenu={this.onUpdateTheTopLeftMenu}
                                       handleHomeSelection={this.handleHomeSelection}
                                       userData={userDataProps}
                                       match={this.props.match}
                                       history={this.props.history}
                                       location={this.props.location}
                                       openLoginPopUp={this.openLoginPopUp}
                                       openSignUpPopUp={this.openSignUpPopUp}
                                       color="#D8DBE2"
                                       bgColor="#403F4c"
                                       textColor="#D8DBE2"
                                       isMapRoom={true}
                                       onSelectArea={this.handleSelectedArea}
                                       resizeMap={this.resizeMap}
                                       hidePopUp={this.hidePopUp}
                        >
                            {this.routeToProjectBoardHomeFeed()}
                            <Helmet>
                                <title>BroadStreet Map {props.boardCardUse.configuration.title}</title>
                            </Helmet>
                            {userDataProps.currentUser.edges.length &&
                            <MapComponent
                                preSavedMap={props}
                                renderMap={this.renderMap}
                                globallyVisible={this.state.globallyVisible}
                                hideCarret={this.hideCarret}
                                onMapLayerOpacityChangedOL={this.handleMapLayerOpacityChanged}
                                onMapLayerUpdate={this.updateMapLayer}
                                handleMapLayerRemoved={this.handleMapLayerRemoved}
                                handleMapLayerGeographyChangedOL={this.handleMapLayerGeographyChanged}
                                onMapLayerPaletteChangedOL={this.handleMapLayerPaletteChanged}
                                handleMapLayerPositionChanged={this.handleMapLayerPositionChanged}
                                onDownloadMap={this.handleDownloadMap}
                                getMapCenterAndZoom={this.getMapCenterAndZoom}
                                getMapPngUrl={this.getMapPngUrl}
                                urlParameters={{mapCardIdToLoad, mapBaseStyleToLoad}}
                                checkedIndicators={this.state.checkedIndicators}
                                fitMapToExtent={this.fitMapToExtent}
                                flyMapToExtent={this.flyMapToExtent}
                                moveAndZoomMap={this.moveAndZoomMap}
                                setPreloadedIndicatorLayers={this.setPreloadedIndicatorLayers}
                                loadPreloadedIndicatorLayers={this.loadPreloadedIndicatorLayers}
                                isLoggedIn={userDataProps != null}
                                hideUnHidePopUp={this.showPopUp}
                                handleSaveCardsPopUp={this.handleSaveCardsPopUp}
                                savedAreaIdSelected={savedAreaIdSelected}
                                onFilterByAreaChange={this.handleFilterByAreaChange}
                                filterByArea={this.state.filterByArea}
                                isSaveMapPopUpVisible={this.state.isSaveMapPopUpVisible}
                                isShareMapPopUpVisible={this.state.isShareMapPopUpVisible}
                                showSaveMapPopUp={this.showSaveMapPopUp}
                                showShareMapPopUp={this.showShareMapPopUp}
                                closePopups={this.closePopups}
                                hidePopUp={this.hidePopUp}
                                isVisible={true}
                                x={this.state.xOriginForMorePopUp}
                                y={this.state.yOriginForMorePopUp}
                                onSelectArea={this.handleMenuSelectArea}
                                onMaskToggle={this.handleMenuMaskToggle}
                                onSaveMap={this.handleMenuSaveMap}
                                onExportMap={this.handleMenuExportMap}
                                onDownloadData={this.handleMenuDownloadData}
                                isMorePopUpVisible={this.state.isMorePopUpVisible}
                                history={this.props.history}
                                match={this.props.match}
                                isLeftMenuOpen={this.state.isLeftMenuOpen}
                                onUnsavedAreaSelected={this.handleUnsavedAreaSelection}
                                areaFilterDisabled={this.state.savingAreaInProgress}
                                updateMapStyleCallback={this.updateMapStyleCallback}
                            />
                            }
                            {this.state.isSelectAreaPopUpVisible === true ?
                                <SelectAreaPopup
                                    hidePopUp={this.hidePopUp}
                                    openCloseServiceSelector={this.openCloseServiceSelector}
                                    handleAreaSelection={this.handleAreaSelection}
                                    popUpRenderAt="PublishBoardAsStoryPopUp"
                                    selectedCardId={this.state.selectedCardForMutation}
                                    isVisible={true}
                                    userData={userDataProps}
                                    location={this.props.location}
                                    history={this.props.history}
                                    match={this.props.match}
                                    x={this.state.xOriginTagCrossPopUp}
                                    y={this.state.yOriginTagCrossPopUp}
                                    showLogin={this.handleLoginPopUp}
                                /> : null}
                        </MenuContainer>);
                }}
            />;
        }
        else {
            return (
                <QueryRenderer
                    environment={environment}
                    query={graphql`
          query RootUserQuery
          {
            currentUser
            {
              edges
              {
                node
                {
                  jsonid
                  username
                  userFirstName
                  userReportName
                  userImage
                  {
                      url
                  }
                }
              }
            }
          }
      `}
                    variables={{isUpdateTopAndLeftMenu: this.state.isUpdateTopAndLeftMenu, userId: this.state.userId}}
                    render={({error, props}) => {
                        //console.log(this.props.match);
                        if (error) {
                            console.error(error);
                            return <div>Error!</div>;
                        }
                        if (!props) {
                            return <div></div>;
                        }
                        var userDataProps = props;

                        if ((userDataProps.currentUser == null || !userDataProps.currentUser.edges.length) &&
                            (this.props.location.pathname !== "/signin" &&
                                this.props.location.pathname !== "/signup")) {
                            this.props.history.push("/signin", {"requestedPage": "/map" + this.props.location.pathname + this.props.location.search})
                        }
                        if ((userDataProps.currentUser != null && userDataProps.currentUser.edges.length) &&
                            (this.props.location.pathname === "/signin" ||
                                this.props.location.pathname === "/signup")) {
                            this.props.history.push("/")
                        }

                        if (window.drift && this.notifiedDriftBot === false && userDataProps.currentUser != null && userDataProps.currentUser.edges[0] != null) {
                            window.drift.on('ready', function () {
                                window.drift.api.setUserAttributes({
                                    email: userDataProps.currentUser.edges[0].node.username,
                                    nickname: userDataProps.currentUser.edges[0].node.userFirstName
                                });
                            });
                            this.notifiedDriftBot = true;
                        }
                        if (window.Appcues != null && userDataProps.currentUser != null && userDataProps.currentUser.edges[0] != null) {
                            if(window.driftUserAttributes == undefined || window.driftUserAttributes.email !== 
                            userDataProps.currentUser.edges[0].node.username) {
                                window.driftUserAttributes = {
                                    email: userDataProps.currentUser.edges[0].node.username,
                                    nickname: userDataProps.currentUser.edges[0].node.userFirstName
                                }
                                window.Appcues.identify(userDataProps.currentUser.edges[0].node.id, {
                                        firstName: window.driftUserAttributes.nickname,
                                        email: window.driftUserAttributes.email
                                    });
                            }
                        }
                        return (
                            <MenuContainer handleBoardSelection={this.handleBoardSelection}
                                           hideCarret={this.hideCarret}
                                           goHome={this.handleGoHome}
                                           onUpdateTheTopLeftMenu={this.onUpdateTheTopLeftMenu}
                                           handleHomeSelection={this.handleHomeSelection}
                                           userData={userDataProps}
                                           match={this.props.match}
                                           history={this.props.history}
                                           location={this.props.location}
                                           openLoginPopUp={this.openLoginPopUp}
                                           openSignUpPopUp={this.openSignUpPopUp}
                                           color="#D8DBE2"
                                           bgColor="#403F4c"
                                           textColor="#D8DBE2"
                                           isMapRoom={true}
                                           onSelectArea={this.handleSelectedArea}
                                           resizeMap={this.resizeMap}
                                           hidePopUp={this.hidePopUp}
                            >
                                {this.routeToProjectBoardHomeFeed()}
                                {userDataProps.currentUser.edges.length &&
                                <MapComponent
                                    renderMap={this.renderMap}
                                    removeMap={this.removeMap}
                                    globallyVisible={this.state.globallyVisible}
                                    hideCarret={this.hideCarret}
                                    onMapLayerOpacityChangedOL={this.handleMapLayerOpacityChanged}
                                    onMapLayerUpdate={this.updateMapLayer}
                                    handleMapLayerRemoved={this.handleMapLayerRemoved}
                                    handleMapLayerGeographyChangedOL={this.handleMapLayerGeographyChanged}
                                    handleMapLayerPositionChanged={this.handleMapLayerPositionChanged}
                                    onMapLayerPaletteChangedOL={this.handleMapLayerPaletteChanged}
                                    onDownloadMap={this.handleDownloadMap}
                                    getMapCenterAndZoom={this.getMapCenterAndZoom}
                                    getMapPngUrl={this.getMapPngUrl}
                                    urlParameters={{mapCardIdToLoad, mapBaseStyleToLoad}}
                                    checkedIndicators={this.state.checkedIndicators}
                                    fitMapToExtent={this.fitMapToExtent}
                                    flyMapToExtent={this.flyMapToExtent}
                                    moveAndZoomMap={this.moveAndZoomMap}
                                    isLoggedIn={(userDataProps.currentUser != null && userDataProps.currentUser.edges[0] != null)}
                                    hideUnHidePopUp={this.showPopUp}
                                    handleSaveCardsPopUp={this.handleSaveCardsPopUp}
                                    savedAreaIdSelected={this.state.savedAreaIdSelected}
                                    onFilterByAreaChange={this.handleFilterByAreaChange}
                                    filterByArea={this.state.filterByArea}
                                    isSaveMapPopUpVisible={this.state.isSaveMapPopUpVisible}
                                    isShareMapPopUpVisible={this.state.isShareMapPopUpVisible}
                                    showSaveMapPopUp={this.showSaveMapPopUp}
                                    showShareMapPopUp={this.showShareMapPopUp}
                                    closePopups={this.closePopups}
                                    hidePopUp={this.hidePopUp}
                                    isVisible={true}
                                    x={this.state.xOriginForMorePopUp}
                                    y={this.state.yOriginForMorePopUp}
                                    onSelectArea={this.handleMenuSelectArea}
                                    onMaskToggle={this.handleMenuMaskToggle}
                                    onSaveMap={this.handleMenuSaveMap}
                                    onExportMap={this.handleMenuExportMap}
                                    onDownloadData={this.handleMenuDownloadData}
                                    isMorePopUpVisible={this.state.isMorePopUpVisible}
                                    history={this.props.history}
                                    match={this.props.match}
                                    onUnsavedAreaSelected={this.handleUnsavedAreaSelection}
                                    areaFilterDisabled={this.state.savingAreaInProgress}
                                    updateMapStyleCallback={this.updateMapStyleCallback}
                                />
                                }
                                {this.state.isSelectAreaPopUpVisible === true ?
                                    <SelectAreaPopup
                                        hidePopUp={this.hidePopUp}
                                        openCloseServiceSelector={this.openCloseServiceSelector}
                                        handleAreaSelection={this.handleAreaSelection}
                                        popUpRenderAt="PublishBoardAsStoryPopUp"
                                        selectedCardId={this.state.selectedCardForMutation}
                                        isVisible={true}
                                        userData={userDataProps}
                                        location={this.props.location}
                                        history={this.props.history}
                                        match={this.props.match}
                                        x={this.state.xOriginTagCrossPopUp}
                                        y={this.state.yOriginTagCrossPopUp}
                                        showLogin={this.handleLoginPopUp}
                                    /> : null}
                            </MenuContainer>);
                    }}/>)
        }
    }
    
    handleLocationChange = (location) => {
        if(window.drift != undefined) {
            try {
                window.drift.page();
            } catch(err) {
                console.log(err);
            }
        }
        if(window.Appcues !== undefined) {
            try {
                window.Appcues.page();
            } catch(err) {
                console.log(err);
            }
        }
    }
    
}


class Root extends Component {
    render() {
        return (
            <Router basename='/map'>
            <div className="h-100">
               <Switch>
                  <Route path='/index.html' render={(routeProps) => (<MapRoomRoot cookies={this.props.cookies} {...routeProps} />)} />
                   <Route exact path='/:areaid(embed)' render={(routeProps) => (<MapRoomEmbedRoot cookies={this.props.cookies} {...routeProps} />)} />
                   <Route exact path='/:areaid(covid)' render={(routeProps) => (<MapRoomCovidRoot cookies={this.props.cookies} {...routeProps} />)} />
                   <Route exact path='/:areaid(indicator)/:id/:summaryLevelCode' render={(routeProps) => (<MapRoomRoot cookies={this.props.cookies} {...routeProps} />)} />
                  <Route exact path='/:areaid' render={(routeProps) => (<MapRoomRoot cookies={this.props.cookies} {...routeProps} />)} />
                  <Route exact path='/' render={(routeProps) => (<MapRoomRoot cookies={this.props.cookies} {...routeProps} />)} />
                   <Route exact path='/:areaid(signup)' render={(routeProps) => (<MapRoomRoot cookies={this.props.cookies} {...routeProps} />)} />
                   <Route exact path='/:areaid(signin)' render={(routeProps) => (<MapRoomRoot cookies={this.props.cookies} {...routeProps} />)} />
               </Switch>
            </div>
         </Router>
    );
  }
}

export default withCookies(Root);



// WEBPACK FOOTER //
// ./src/components/Root/index.js